

const initialState = {
    regionType: '',
    id: '',
    centerX: '',
    centerY: '',
    width: '',
    height: '',
    classification: '',
    color: '',       
  };
  
  
  const annotationReducer = (state = initialState, action: any) => {
    console.log(action.payload, action.type);
    
    switch (action.type) {
      case "SET_ANNOTATION_OUTPUT":
        return { ...state, ...action.payload };
      default:
        return state;
    }
  };
  
  export default annotationReducer;